/**
 * Kaleidoscope `File` component set (Figma P38Omrcw… `4846:11897`) — which
 * colour a file's tile takes and which three characters are lettered across it.
 *
 * Split from the component so Fast Refresh keeps working: a module exporting
 * both a component and plain values loses its refresh boundary.
 */

export type FileKind = 'pdf' | 'doc' | 'image' | 'other';

// Figma: #E4626F / #797DFF / #15B097 / #F3F4F9 — every one a real token, so
// none of them is written as a hex here.
export const KIND_BG: Record<FileKind, string> = {
  pdf: 'error-100',
  doc: 'primary-400',
  image: 'success-200',
  other: 'secondary-50',
};

// The design system letters the tile with a three-character kind, which is why
// docx reads DCX rather than being truncated to DOC and colliding with it.
export const EXTENSION_LABEL: Record<string, string> = {
  pdf: 'PDF',
  doc: 'DOC',
  docx: 'DCX',
  odt: 'ODT',
  png: 'PNG',
  jpg: 'JPG',
  jpeg: 'JPG',
};

export const EXTENSION_KIND: Record<string, FileKind> = {
  pdf: 'pdf',
  doc: 'doc',
  docx: 'doc',
  odt: 'doc',
  png: 'image',
  jpg: 'image',
  jpeg: 'image',
};

/** Extension wins over MIME: a server record may carry neither, or a generic one. */
export const fileExtension = (filename?: string, mimeType?: string): string => {
  const fromName = filename?.split('.').pop()?.toLowerCase() ?? '';
  if (fromName && EXTENSION_KIND[fromName]) return fromName;
  const fromMime = mimeType?.split('/').pop()?.toLowerCase() ?? '';
  return EXTENSION_KIND[fromMime] ? fromMime : fromName;
};
